// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ImageView_componentStyle__EyvhN","defaultSize":"ImageView_defaultSize__OAZks","isFreeSize":"ImageView_isFreeSize__oo4kU","isCircled":"ImageView_isCircled__GpvWN"};